import React from 'react'
import { PropTypes } from 'prop-types'
import { withNamespaces } from "react-i18next"
import { compose } from 'redux'

export class RoomInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      expandRoomCode: false
    }
    this.handleRoomCodeExpand = this.handleRoomCodeExpand.bind(this)
  }

  handleRoomCodeExpand(e) {
    e.preventDefault()
    this.setState({ expandRoomCode: true })
  }

  timeFormat(val) {
    return `${(!val) ? '00' : val}:00`
  }

  lawType() {
    switch (this.props.law_type) {
    case 'vacation_rental_law':
      return '住宅宿泊事業法'
    case 'specific_distinct_law':
      return '戦略特区法'
    case 'hotel_business_law':
      return '旅館業法'
    }
  }

  render() {
    const { t } = this.props
    return (
      <section>
        <h2>{ t('room_info.title') }</h2>
        <ul className="column2-list-wrap">
          <li className="column2-list">
            <dl className="column-table">
              <dt className="column-table-title">{ t('calendar.checkin') }</dt>
              <dd className="column-table-detail">{(this.props.checkin_from == this.props.checkin_to) ? this.timeFormat(this.props.checkin_from) : `${this.timeFormat(this.props.checkin_from)}〜${this.timeFormat(this.props.checkin_to)}`}</dd>
            </dl>
          </li>
          <li className="column2-list">
            <dl className="column-table">
              <dt className="column-table-title">{ t('room_info.minimum_stay') }</dt>
              <dd className="column-table-detail"><span className="notranslate">{this.props.minimum_stays}</span>{ t('room_info.night') }</dd>
            </dl>
          </li>
          <li className="column2-list">
            <dl className="column-table">
              <dt className="column-table-title">{ t('calendar.checkout') }</dt>
              <dd className="column-table-detail">{this.timeFormat(this.props.checkout_to)}</dd>
            </dl>
          </li>
          <li className="column2-list">
            <dl className="column-table">
              <dt className="column-table-title">{ t('room_info.maximum_stay') }</dt>
              <dd className="column-table-detail"><span className="notranslate">{this.props.maximum_stays}</span>{ t('room_info.night') }</dd>
            </dl>
          </li>
        </ul>
        <dl className="column1-list column-table">
          <dt className="column-table-title">{ t('room_info.registration_verified') }</dt>
          <dd className="column-table-detail">
            {this.props.available_room_codes.length > 0 &&
              <div>
                {this.state.expandRoomCode == true
                  ? this.props.available_room_codes.join('、')
                  : <React.Fragment>
                    <span className="notranslate">
                      {this.props.available_room_codes[0]}
                    </span>
                    {this.props.available_room_codes.length > 1 &&
                      <span>&nbsp;<a href="" onClick={this.handleRoomCodeExpand}>...
                        { t('room_info.other') }
                        <span className="notranslate">{ this.props.available_room_codes.length - 1 }</span>
                        { t('room_info.items', { count: this.props.available_room_codes.length - 1 }) }
                      </a></span>
                    }
                  </React.Fragment>
                }
              </div>
            }
          </dd>
        </dl>
      </section>
    )
  }
}

RoomInfo.propTypes = {
  checkin_from: PropTypes.number.isRequired,
  checkin_to: PropTypes.number.isRequired,
  checkout_to: PropTypes.number.isRequired,
  minimum_stays: PropTypes.number.isRequired,
  maximum_stays: PropTypes.number.isRequired,
  available_room_codes: PropTypes.array.isRequired,
  law_type: PropTypes.string.isRequired
}

RoomInfo.defaultProps = {
  checkin_from: 0,
  checkin_to: 0,
  checkout_to: 0,
  minimum_stays: 0,
  maximum_stays: 0,
  available_room_codes: []
}

export default compose( withNamespaces('listings') )(RoomInfo)
